<script lang="ts" setup="">
import type { AuthorLocalised } from '@pkg/sanity-utils/types/author';
import { authorsPathSegment } from '../../../../../sanity/schemas/utils/slugs/slugConstants';

const props = defineProps<{
  author: AuthorLocalised;
}>();

const localePath = useLocalePath();

const person = computed(() => ({
  _key: props.author.name || '',
  name: props.author.name,
  jobTitle: props.author.jobTitle,
  image: props.author.image,
}));

const authorUrl = computed((): string | undefined => {
  const authorSlug = props.author.slug?.current;
  if (authorSlug && props.author.hasBio) {
    return localePath(`/${authorsPathSegment}/${authorSlug}`);
  }
  return undefined;
});

</script>

<template>
  <div class="flex items-center gap-x-[16px]">
    <ProfilePicture :person="person" :size="2" />
    <div class="flex flex-col">
      <NuxtLink v-if="authorUrl" :to="authorUrl" class="name c-post-author--link">
        {{ props.author.name }}
      </NuxtLink>
      <span v-else class="name">
        {{ props.author.name }}
      </span>
      <strong class="job-title">{{ props.author.jobTitle }}</strong>
    </div>
  </div>
</template>

<style scoped>
@import '~/assets/css/mixins/_mixins.index.pcss';

.name {
  @mixin h5;
  color: var(--var-title-header-color);
  text-transform: uppercase;
}

.job-title {
  @mixin body-small;
  color: var(--theme-tertiary-text-color);
  font-weight: 700;
}

.c-post-author--link {
  text-decoration: underline;
  color: var(--btn-text-type);
  transition: color 0.3s ease;

  &:hover {
    color: var(--btn-text-hover-type);
  }
}
</style>
